var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{class:[`dg-loading-indicator `]},[_c('span',{staticClass:"icon"}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.label))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }